import { z } from 'zod';

export function orderedQuantitySchema(quantityPerPackage: number | null) {
  return z
    .number({ error: 'quantityPositiveInteger' })
    .int({ error: 'quantityPositiveInteger' })
    .positive({ error: 'quantityPositiveInteger' })
    .refine(
      (quantity) =>
        quantityPerPackage === null ||
        quantityPerPackage <= 1 ||
        quantity % quantityPerPackage === 0,
      { error: 'quantityMultipleQtyCtn' },
    );
}
